// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__2CUjF","upload":"Small_upload__27KIp","imageWrap":"Small_imageWrap__AjuX1","removeBtn":"Small_removeBtn__gCe-Z"};